import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse } from '@material-ui/core';
import cx from 'classnames';
import React, { useState } from 'react';
import { FBMediaAlbumField, FBProcedureItemLocale, FBProcedureItemType } from '../..';
import { translate } from '../../../../common/intl';
import useStyles from '../FBMPIProcedureItem.styles';
import { FBMPIProcedureItemProps } from '../FBMPIProcedureItem.types';

type AttachmentsProps = Pick<FBMPIProcedureItemProps, 'stepIndex' | 'name' | 'defaultValue'> & { deviationHighlightedIds?: Set<string> };

const Attachments: React.FC<AttachmentsProps> = ({
  name = '_undefined_',
  defaultValue,
  deviationHighlightedIds,
}) => {
  const classes = useStyles();
  const hasAttachments = defaultValue?.length > 0;
  const [isAttachmentExpanded, setIsAttachmentExpanded] = useState(hasAttachments);
  const [hasExpanded, setHasExpanded] = useState(hasAttachments);
  const panelId = `${name}-attachments-panel`;

  const toggleAttachments = () => {
    setHasExpanded(true);
    setIsAttachmentExpanded(prev => !prev);
  };

  return (
    <>
      <button
        type="button"
        className={classes.attachmentHeader}
        onClick={toggleAttachments}
        aria-expanded={isAttachmentExpanded}
        aria-controls={panelId}
      >
        <span data-cy={FBProcedureItemLocale[FBProcedureItemType.attachments]}>
          {translate(FBProcedureItemLocale[FBProcedureItemType.attachments])}
        </span>
        <FontAwesomeIcon icon={regular('chevron-down')} className={cx(classes.expandIcon, { [classes.expandIconRotated]: isAttachmentExpanded })} />
      </button>
      <Collapse in={isAttachmentExpanded}>
        <div id={panelId}>
          {hasExpanded && (
            <div data-cy="media-upload-field">
              <FBMediaAlbumField
                name={`${name}.attachments`}
                isTemplate={true}
                editorProperties={['copyableValue']}
                gutter={false}
                editorConfig={defaultValue}
                autosave={false}
                fieldType="mpiprocedure"
                deviationHighlightedIds={deviationHighlightedIds}
              />
            </div>
          )}
        </div>
      </Collapse>
    </>
  );
};

export default Attachments;
